var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-calendar',{ref:"calendar",style:({ height: '200px' }),attrs:{"title":" ","poppable":false,"show-confirm":false,"show-title":false,"show-subtitle":false,"row-height":40,"min-date":_vm.minDate,"max-date":_vm.maxDate,"default-date":_vm.today,"lazy-render":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }